var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRight = function SvgRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 6,
    "data-width-24": 9,
    viewBox: "0 0 9 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.72 0a.74.74 0 0 1 .53.22l7 7a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.03-1.06l6.44-6.47L.22 1.28A.75.75 0 0 1 .72 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRight);
export default ForwardRef;